import React from 'react';
import {useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import {CompanyNeighborHoodPriceProps} from 'modules/companies/types';
import useCompanyNeighborhoodPrices from 'modules/companies/hooks/use-company-neighborhood-prices';
import companiesKeys from 'modules/companies/util/companies-keys';
import toBrl from 'shared/util/to-brl';

const NeighborhoodPrices: React.FC = () => {
  const {id} = useParams();
  const {data = [], isLoading} = useCompanyNeighborhoodPrices(id!);

  return (
    <Table<CompanyNeighborHoodPriceProps>
      loading={isLoading}
      {...{data}}
      options={[
        'neighborhood.name',
        {
          value: 'deliveryPrice',
          column: (data) => data.deliveryPrice && toBrl(data.deliveryPrice),
        },
        {
          value: 'deliveryManFee',
          column: (data) => data.deliveryManFee && toBrl(data.deliveryManFee),
        },
        {
          value: 'id',
          column: (row) => (
            <QueryDeleteButton
              queryKey={companiesKeys.neighborhoodPrices(id!)}
              url={`/neighborhoods/company-prices/${row.id}`}
              type="update"
            />
          ),
        },
      ]}
      translatedPropsKey="CompanyNeighborhoodPriceProps"
    />
  );
};

export default NeighborhoodPrices;
